import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a2366f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "welcome-cards" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "welcome-cards__icon" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "welcome-cards__title" };
import i18n from '@/i18n';
import router from '@/router';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { reactive } from 'vue';
var MixpanelEvents;
(function (MixpanelEvents) {
    MixpanelEvents["OTO_ACADEMY"] = "home_clicked_btn-oto-academy";
    MixpanelEvents["ENGAGEMENT_REPORT"] = "home_clicked_btn-engagement-report";
    MixpanelEvents["SALES_REPORT"] = "home_clicked_btn-sales-report";
    MixpanelEvents["SELLERS"] = "home_clicked_btn-sellers";
    MixpanelEvents["SUPPORT"] = "home_clicked_btn-help";
})(MixpanelEvents || (MixpanelEvents = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'WelcomeCards',
    setup(__props) {
        const { tc } = i18n.global;
        const { push } = router;
        const cards = reactive([
            {
                title: tc('welcome.cards.academy.title'),
                icon: 'graduation',
                link: '/oto-academy',
                mixpanelEvent: MixpanelEvents.OTO_ACADEMY,
            },
            {
                title: tc('welcome.cards.indicators.title'),
                icon: 'report',
                link: '/campaigns/campaign-engagement',
                mixpanelEvent: MixpanelEvents.ENGAGEMENT_REPORT,
            },
            {
                title: tc('welcome.cards.sales.title'),
                icon: 'money',
                link: '/campaigns/campaign-sales-report',
                mixpanelEvent: MixpanelEvents.SALES_REPORT,
            },
            {
                title: tc('welcome.cards.sellers.title'),
                icon: 'users',
                link: '/store/sellers',
                mixpanelEvent: MixpanelEvents.SELLERS,
            },
            {
                title: tc('welcome.cards.support.title'),
                icon: 'question',
                link: 'https://ajuda.otocrm.com.br/support/home',
                mixpanelEvent: MixpanelEvents.SUPPORT,
            },
        ]);
        function redirect(item) {
            useMixpanelConfig(item.mixpanelEvent);
            if (item.mixpanelEvent === MixpanelEvents.SUPPORT) {
                return window.open(item.link, '_blank');
            }
            push(item.link);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        onClick: ($event) => (redirect(item)),
                        class: "welcome-cards__item"
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                                src: require(`@/assets/img/icons/welcome/${item.icon}.svg`),
                                alt: _ctx.$t('360.dialog.alert-icon')
                            }, null, 8, _hoisted_4)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("p", null, _toDisplayString(item.title), 1)
                        ])
                    ], 8, _hoisted_2));
                }), 128))
            ]));
        };
    }
});
